<template>
	<div class="container-buy">
		<div class="buy-tap" id="buy_display">
			<div class="buy-tap-item clearfix">
				<BuyTapFree @viewDetail="viewDetail"></BuyTapFree>
				<BuyTapPro
					:upgradeVersion="upgradeVersion"
					:modalShow="modalShow"
					@viewDetail="viewDetail"
				></BuyTapPro>
				<BuyTapAdvance
					:upgradeVersion="upgradeVersion"
					:modalShow="modalShow"
					@viewDetail="viewDetail"
				></BuyTapAdvance>
			</div>
		</div>
		<modal :closeable="false" v-model="modalShow" :modalInfo="modalInfo">
			<div slot="header"></div>
			<BuyDetail
				:coupon="coupon"
				@closeDetail="closeDetail"
				@recommendAnnual="recommendAnnual"
				:version="version"
			></BuyDetail>
			<div slot="footer"></div>
		</modal>
		<modal :closeable="false" v-model="irresistibleModalShow">
			<div slot="header"></div>
			<IrresistibleDiscountModal :coupon="coupon" @close="closeDetail" />
			<div slot="footer"></div>
		</modal>
		<modal v-model="extraFeeModalShow" :closeable="true">
			<div slot="header"></div>
			<ExtraFeeModal
				:coupon="coupon"
				:plan="plan"
				:payUrl="payUrl"
				@payAnnual="payAnnual"
				@closeDetail="closeDetail"
			/>
			<div slot="footer"></div>
		</modal>
	</div>
</template>
<script>
import { getCouponCode, createPromotionCoupon } from '../../../../utils/coupon'
import BuyTapFree from './BuyTapFree'
import BuyTapPro from './BuyTapPro'
import BuyTapAdvance from './BuyTapAdvance'

const PRO_VERSION = 2
const ADVANCE_VERSION = 3

const unescapeHtmlDangerously = text => {
	const div = document.createElement('div')
	div.innerHTML = text
	return div.innerText
}

export default {
	data() {
		return {
			version: '',
			modalShow: false,
			irresistibleModalShow: false,
			extraFeeModalShow: false,
			coupon: {},
			storedCoupon: {},
			detailType: '',
			modalInfo: {
				width: 650,
				top: 100,
			},
			upgradeVersion: null,
			plan: {},
			payUrl: '',
		}
	},
	computed: {},
	components: {
		BuyTapFree,
		BuyTapPro,
		BuyTapAdvance,
		BuyDetail: () =>
			import(/* webpackChunkName: "BuyDetail" */ '../BuyDetail/index.vue'),
		IrresistibleDiscountModal: () =>
			import(
				/* webpackChunkName: "IrresistibleDiscountModal" */ '../IrresistibleDiscountModal.vue'
			),
		ExtraFeeModal: () =>
			import(/* webpackChunkName: "ExtraFeeModal" */ '../ExtraFeeModal.vue'),
	},
	methods: {
		parseCoupon(couponData) {
			let coupon = couponData
			if (couponData.coupon_code && !couponData.isCouponInvalid) {
				coupon.user_name = unescapeHtmlDangerously(PageInfo.user_name)
			}

			const now = new Date().getTime()
			const storedCouponStr = localStorage.getItem('WS-141957_coupon')
			const storedCoupon = storedCouponStr && JSON.parse(storedCouponStr)
			if (
				storedCoupon &&
				storedCoupon.coupon_code === coupon.coupon_code &&
				storedCoupon.user_name === coupon.user_name &&
				storedCoupon.expire_time < now
			) {
				coupon.isCouponInvalid = true
			}

			this.coupon = coupon
			this.storedCoupon = storedCoupon
		},
		viewDetail(v, openOnMounted) {
			this.$Loading.show()
			getCouponCode
				.then(couponData => {
					this.parseCoupon(couponData)
					const { coupon, storedCoupon } = this
					this.version = v
					if (couponData.isIrresistible && openOnMounted) {
						const now = new Date().getTime()
						if (
							storedCoupon &&
							storedCoupon.coupon_code === coupon.coupon_code &&
							storedCoupon.user_name === coupon.user_name
						) {
							if (storedCoupon.expire_time < now) {
								if (v) {
									this.coupon = {}
									this.modalShow = true
								}
								return
							}
							this.coupon.expire_time = storedCoupon.expire_time
						} else {
							localStorage.setItem(
								'WS-141957_coupon',
								JSON.stringify(this.coupon),
							)
						}
						this.irresistibleModalShow = true
					} else if (v) {
						this.modalShow = true
					}
				})
				.finally(() => {
					this.$Loading.hide()
				})
		},
		closeDetail() {
			this.modalShow = false
			this.irresistibleModalShow = false
			this.extraFeeModalShow = false
		},

		getVisibleUpdateVersion() {
			if (!this.modalShow) {
				// 直接从pageInfo取出当前账号订阅的版本
				const accountVersion = PageInfo.accountState
				if (accountVersion === PRO_VERSION) return 'pro'
				if (accountVersion === ADVANCE_VERSION) return 'advance'
			}
			return null
		},

		payAnnual() {
			this.extraFeeModalShow = false
			// 解决 modal-bg 意外不渲染问题
			setTimeout(() => {
				if (this.coupon.isCouponInvalid) {
					this.modalShow = true
				} else {
					this.irresistibleModalShow = true
				}
			}, 0)
		},

		recommendAnnual(plan, payUrl) {
			// 过期超过14天才给优惠券
			if (new Date().getTime() - PageInfo.expireDate < 14 * 24 * 3600 * 1000) {
				this.plan = plan
				this.payUrl = payUrl
				this.modalShow = false
				this.extraFeeModalShow = true
			} else {
				this.$Loading.show()
				createPromotionCoupon()
					.then(couponData => {
						this.parseCoupon(couponData)
						this.plan = plan
						this.payUrl = payUrl
						this.modalShow = false
						this.extraFeeModalShow = true
					})
					.finally(() => {
						this.$Loading.hide()
					})
			}
		},
	},
	mounted() {
		this.viewDetail(this.getVisibleUpdateVersion(), true)
	},
}
</script>

<style lang="scss">
.container-buy {
	background: #fbfbfb;

	.buy-tap {
		padding-top: 32px;
		padding-bottom: 54px;
		text-align: center;
	}
	.buy-tap-item {
		position: relative;
		display: inline-block;
	}
}
.limit-tips {
	position: relative;
	top: 2px;
}
.tp-op-use.active {
	button {
		background: #299bff;
		color: #fff;
		width: 280px;
		height: 40px;
		line-height: 40px;
		border: none;
		cursor: pointer;
		box-shadow: 0 3px 6px 0 rgba(0, 112, 211, 0.25);
		&:hover {
			box-shadow: 0 3px 6px 0 rgba(0, 112, 211, 0.25);
			background: #5fb4ff;
		}
	}
}
.tp-op-benifit {
	padding-top: 20px;
	font-size: 14px;
	line-height: 20px;
	text-align: left;
	display: inline-block;
	.icon {
		position: absolute;
		left: 0;
		top: 2px;
		width: 16px;
		height: 16px;
	}
}
.tp-op-benifit li {
	position: relative;
	margin-top: 24px;
	text-indent: 28px;
}
</style>
